import script from "./AppNavAccountBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavAccountBtn.vue?vue&type=script&setup=true&lang=ts"

import "./AppNavAccountBtn.vue?vue&type=style&index=0&id=26195a3a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26195a3a"]])

export default __exports__